import React, { useEffect, useState } from "react";
import Layout from "../../NewComponent/LayoutExpert/Layout";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "../../NewComponent/SearchBar/SearchBar";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { getExpertOpenPageData, ExpertOpenTabSearchQuestions } from "../../API/api";
import { Grid } from "@mui/material";
import SelectComp from "../../NewComponent/Select/Select";
import TabSearch from "../../NewComponent/TabSearch/tabSearch";
import MultiSelectExpretOpenPage from "./MultiSelectExpertOpenPage";
import PaginationComp from "../../NewComponent/Pagination/Pagination";
import { Spin, Empty } from "antd";
import QuestionBox from "./QuestionBox";
import KeyTagDataBox from "../KeyTermExpertPage/KeyTagDataBox";
import { getKeyTag } from "../../API/api";
import debounce from "lodash.debounce";
import { useCallback } from 'react';
export default function ExpertOpenPage() {
	const keyTagState = useSelector(state => state.keyTag);
	const recommendState = useSelector((state)=>state.recommend);
	const expertState = useSelector((state) => state.expertOpenData);
	const userState = useSelector((state) => state.user);
	const [domainNames, setDomainNames] = useState([])
	const [dropwDownOpt, setDropDown] = useState(expertState.sortOptions);
	const [selectedValue, setSelectedValue] = useState(expertState.ownRecords ? 'assigned to me' : 'assigned to others');
	const dispatch = useDispatch();
	const [domain, setDomain] = useState(expertState.domainFilter || []);
	const { isBackClickedOnRecommend,updatePageNumberExpertOpenTab,
		getIsOpenedQuestion, isDataLoadingExpertOpen,
		getExpertOpenData,
		getOpenDataCountExpert, getDomainValuesInExpertOpen, sortChangeExpertOpenPage, getTabSearchInputForExpertOpen, updateSortOptionsExpertOpen, sortFilterDefaultExpert, ownRecordsValue } = bindActionCreators(Actions, dispatch)

	const container = {
		width: "74%",
		margin: "auto",
		marginTop: "1%",
		marginBottom: "7%",
		border: "1px solid #E0E2E6",
		background: "#FFFFFF",
		borderRadius: "12px",
		boxShadow: "0px 4px 16px 0px #1018280F",
		padding: "28px",
	};

	const isCheckRelevance = (str) => {
		let isThere = false;
		for (let i = 0; i < str.length; ++i) {
			if (str[i].label === "Relevance") {
				isThere = true;
			}
		}
		return isThere;
	};

	const onClearValue = () => {
		getTabSearchInputForExpertOpen('')
		sortChangeExpertOpenPage(false);
		let sdf = [...expertState.sortOptions]
		sdf.pop()
		sortFilterDefaultExpert(expertState.sortOptions[0]);
		updateSortOptionsExpertOpen(sdf)
	}

	const onChangeTabSearchVal = (e) => {
		if (e.target.value.length !== 0) {
			sortChangeExpertOpenPage(false)
			if (isCheckRelevance(expertState.sortOptions)) {
				getTabSearchInputForExpertOpen(e.target.value);
			} else {
				updateSortOptionsExpertOpen(expertState.sortOptions.concat([expertState.relevanceObj]));
				sortFilterDefaultExpert(expertState.relevanceObj);
				getTabSearchInputForExpertOpen(e.target.value);
			}
		}
		if (e.target.value.length === 0) {
			onClearValue();
		}
	}

	const onChangeDropdown = (val) => {
		// sortFilterVal: { id:"1",value: "recently asked", label: "Recently Asked", origValue:'questionAsked', sortOrder:'desc' }
		// let newObj = {
		// 	id: "1", value: val, label: val === 'recently asked' ? 'Recently Asked' : 'Oldest Asked', origValue: 'questionAsked', sortOrder: val === 'recently asked' ? 'desc' : 'asc'
		// }
		let newObj = {
			id: "1", value: val.value, label: val.label, origValue: (val.value === 'answered' || val.value === 'unanswered') ? 'answered' : 'questionAsked', sortOrder: (val.value === 'answered' || val.value === 'oldest asked') ? 'asc' : 'desc'
		}
		sortFilterDefaultExpert(newObj)
		sortChangeExpertOpenPage(true)
	}

	const onChangeOptions = (val) => {
		setSelectedValue(val)
		if (val.key === "assigned to me") {
			ownRecordsValue(true)
		}
		if (val.key === "assigned to others") {
			ownRecordsValue(false)
		}
	}

	const onChangePageEvent = (e) => {
		updatePageNumberExpertOpenTab(e - 1);
	}

	useEffect(() => {
		isDataLoadingExpertOpen(true);
		getIsOpenedQuestion(false);
		// console.log(expertState,'check check check')
		if (expertState.tabSearchValue === "") {
			getExpertOpenPageData(
				expertState.pageNo,
				expertState.sortFilterVal.origValue,
				expertState.sortFilterVal.sortOrder,
				expertState.sortChange,
				expertState.domainFilter,
				expertState.ownRecords
			).then((res) => {
				if (res === undefined) return;
				if (res.data.success === true || res.data.data !== "") {
					getExpertOpenData(res.data.data);
					getOpenDataCountExpert(res.data.count);
					isDataLoadingExpertOpen(false);
					getIsOpenedQuestion(true)
					let quesTds = res?.data?.data?.map((obj) => obj.questionUuid)
					if (quesTds && quesTds.length > 0) {
						getKeyTag(quesTds)
					}
				}
			});
		} else if (
			expertState.tabSearchValue !== "" &&
			expertState.tabSearchValue.length >= 3
		) {
			const payload = {
				category: null,
				solarIndex: 0,
				question: expertState.tabSearchValue,
				page: expertState.pageNo,
				status: "open",
				sortOrder: expertState.sortFilterVal.sortOrder,
				sortFilter: expertState.sortFilterVal.origValue,
				sortChange: expertState.sortChange,
				domain: encodeURIComponent(
					expertState.domainFilter.map((dom) => dom.name.toString())
				),
				curationCategory: null,
				transferred: false,
				ownRecords: expertState.ownRecords,
			};
			ExpertOpenTabSearchQuestions(payload)
				.then((res) => {
					if (res === undefined) return;
					getExpertOpenData(res.data.data);
					getOpenDataCountExpert(res.data.count);
					isDataLoadingExpertOpen(false);
					let quesTds = res.data.data.map((obj) => obj.questionUuid)
					if (quesTds && quesTds.length > 0) {
						getKeyTag(quesTds)
					}
				})
				.catch((err) => console.log(err));
		}	
		setDomainNames(() => {
			let options = userState.expertTopics.map((obj, ind) => {
				return { value: obj.name, label: obj.name, id: obj.id }
			})
			return options;
		})
		setDropDown(expertState.sortOptions);
	}, [
		expertState.pageNo,
		expertState.tabSearchValue,
		expertState.domainFilter,
		expertState.sortChange,
		expertState.sortFilterVal,
		expertState.ownRecords,
		// expertState.reloadPage,
	])
	// console.log("open question",expertState)
 const onchangeDomain = (val) => {
		setDomain(val)
		debouncedFetchOptions(val)
	}
	const debouncedFetchOptions = useCallback(
		debounce((value) => getDomainValuesInExpertOpen(value), 2000),
		[]
	  );
	useEffect(()=>{
		const scrollPos = expertState.getScrollPosition;		  
		if (typeof scrollPos === 'number' && !isNaN(scrollPos)) {
			window.scrollTo({ top: scrollPos, behavior: 'smooth' });
		}
	})

	return (
		<>
			<Layout>
				{!keyTagState.isBack &&
					<div style={{ width: '74%', margin: 'auto', marginTop: '1%', marginBottom: "3%" }}>
						<SearchBar />
					</div>
					}
				<div style={container}>
					{!keyTagState.isBack && <>
						<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap',paddingBottom:'12px' }}>
							<div style={{
								fontSize: '16px',
								fontWeight: 500,
								lineHeight: '24px',
								textAlign: 'left',
								color: '#2A364A',
								width: '100%',
								display: 'flex',
								justifyContent: 'space-between'
							}}>Open Question(s){" "}{expertState.openCount !== undefined && expertState?.isLoading === false && expertState?.openCount}{
									expertState?.isLoading && "0"
								}</div>
							<div>
							</div>
						</div>
						<div
							style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', marginBottom: '12px'}}
						>
							{/* Search Field - Responsive width */}
							<div>
								<TabSearch width={'160px'} size="large" val={expertState.tabSearchValue} onChangeFunc={(e) => onChangeTabSearchVal(e)} />
							</div>
							{/* Filters - Full width on small screens, align right on large screens */}
							<div style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px'}}
							>
								<div >
								<SelectComp
									labelInValue={true}
									isString={false}
									val={expertState.sortFilterVal.value}
									options={dropwDownOpt}
									size="large"
									onChangeFunc={(e) => onChangeDropdown(e)}
									width={'150px'}
								/>
								</div>
								<div >
								<SelectComp
									isString={false}
									labelInValue={true}
									val={selectedValue}
									options={expertState.expertSelectOptions}
									size="large"
									width={'200px'}
									onChangeFunc={(e) => onChangeOptions(e)}
								/>
								</div>
								<div>
								<MultiSelectExpretOpenPage
									value={domain}
									onChangeFunc={onchangeDomain}
									options={domainNames}
									// width={'100%'}
								/>
								</div>
							</div>
						</div>

						{
							expertState.isLoading && (
								<div style={{ display: 'flex', justifyContent: 'center',minHeight:'15vh' }}>
									<Spin spinning={true} size={'large'}>
									</Spin>
								</div>
							)
						}
						{
							expertState.isLoading === false && expertState?.openPageData?.length === 0 && (
								<Empty />
							)
						}
						{
							expertState.isLoading === false && expertState.openPageData && expertState.openPageData.length > 0 &&
							(
								expertState.openPageData.map((data, i) => {
									return (<QuestionBox data={data} key={i} />)
								})
							)
						}
						{(expertState?.isLoading === false && expertState?.openPageData?.length > 0) && <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<PaginationComp page={expertState.pageNo + 1} total={expertState.openCount} onChangeFunc={onChangePageEvent} />
						</div>}
					</>}
					{keyTagState.isBack && <KeyTagDataBox />}
				</div>
			</Layout>
		</>
	)
}